import React, { useContext } from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import { onBetToggle } from './onBetToggle';
import { useMediaQuery } from '@/components/utils/useQueryMedia';

const ContainerDiv = styled.div((props) => props.$styleText);

export const Container = (componentProps) => {
  let props = componentProps;

  const dataElementContext = useContext(DataElementContext);
  let isVisible = true;

  const isTablet = useMediaQuery(`(min-width: ${window.config.breakpointTablet})`);
  const isDesktop = useMediaQuery(`(min-width: ${window.config.breakpointDesktop})`);
  const breakpoints = React.useMemo(() => ({ isTablet, isDesktop }), [isTablet, isDesktop]);

  [props, isVisible] = processComponentProps(props, dataElementContext, breakpoints);

  if (!isVisible) return null;

  let onClick = null;
  if (props.properties && props.properties.onClick && typeof props.properties.onClick === 'function') {
    onClick = props.properties.onClick;
  } else if (
    componentProps.properties &&
    componentProps.properties.onClick &&
    typeof componentProps.properties.onClick === 'function'
  ) {
    onClick = componentProps.properties.onClick;
  }

  if (props?.properties?.betHolder) {

    if (typeof onClick !== 'function') {
      // special case; onClick handler for all of our odds
      onClick = onBetToggle;
    } else {
      const originalOnClick = onClick;
      onClick = (e) => {
        onBetToggle(e);
        originalOnClick(e);
      };
    }
  }

  const extraDataProps = {};
  if (props?.properties) {
    Object.keys(props?.properties).forEach((key) => {
      if (key.indexOf('data-') === 0) {
        extraDataProps[key] = props?.properties[key];
      }
    });
  }

  if (props?.properties?.key) {
    extraDataProps['key'] = props?.properties?.key;
  }

  if (props?.properties?.title) {
    extraDataProps['title'] = props?.properties?.title;
  }

  return (
    <ContainerDiv
      className={props.className ?? ''}
      $styleText={props.styleText}
      onClick={onClick}
      style={props.style}
      id={props?.properties?.id}
      data-node-id={props.nodeId}
      {...extraDataProps}
    >
      {componentProps.children}
    </ContainerDiv>
  );
};
